export const HOLIDAY_ACTIONS = Object.freeze({
    add: 'add',
});
export const holidayReducer = (state, action) => {
    switch (action.type) {
        case HOLIDAY_ACTIONS.add:
            return [
                ...state,
                {
                    date: action.payload,
                    month: action.payload.month(),
                    year: action.payload.year(),
                    displayText: action.payload.format('MMM D'),
                },
            ];
        default:
            return state;
    }
};
//# sourceMappingURL=holidayReducer.js.map